// extracted by mini-css-extract-plugin
export var cardLayout = "_89-1";
export var paginationContainer = "_89-0";